import {
  createScheduleSummary,
  plannedSessionTimesFromForm
} from './schedule.js';

export function createSessionScheduleController({
  sessionEditor,
  getStageSummaries=()=>[]
}={}){
  if(!sessionEditor?.snapshot||!sessionEditor?.autosave){
    throw new TypeError('Smoking session editor is required');
  }
  if(typeof getStageSummaries!=='function')throw new TypeError('getStageSummaries must be a function');

  async function summary(){
    const session=sessionEditor.snapshot().session;
    if(!session)throw new Error('SMOKING_SESSION_NOT_OPEN');
    const stageSummaries=await getStageSummaries(session.id);
    return createScheduleSummary({
      plannedStartAt:session.plannedStartAt,
      plannedEndAt:session.plannedEndAt,
      stageSummaries
    });
  }

  async function save(formData,{utcOffsetMinutes=null,timeZone=null}={}){
    const times=plannedSessionTimesFromForm(formData,{utcOffsetMinutes,timeZone});
    const result=await sessionEditor.autosave(times);
    return Object.freeze({
      ...result,
      schedule:await summary()
    });
  }

  return Object.freeze({save,summary});
}
